// src/components/ProductGrid.js
import React, { useState, useEffect } from "react";
import ProductCard from "./ProductCard";
import "../styles/product.css";
import { useNavigate } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../utils/firebaseconfig";

function ProductGrid({ filter }) {
  const navigate = useNavigate();
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const snapshot = await getDocs(collection(db, "Product"));
        const products = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

        // Filter out auction products (exclude products where isAuction is true)
        const nonAuctionProducts = products.filter((product) => !product.isAuction);

        // First apply category filter if it exists
        let filteredProducts = [...nonAuctionProducts];
        if (filter && !["price-low-high", "price-high-low", "alphabetic-asc", "alphabetic-desc", "rating-high-low", "rating-low-high", "popularity"].includes(filter)) {
          filteredProducts = nonAuctionProducts.filter(product => 
            product.category && product.category.toLowerCase() === filter.toLowerCase()
          );
        }

        // Then apply sorting if a sort filter is selected
        let sortedProducts = [...filteredProducts];
        switch (filter) {
          case "price-low-high":
            sortedProducts.sort((a, b) => a.price - b.price);
            break;
          case "price-high-low":
            sortedProducts.sort((a, b) => b.price - a.price);
            break;
          case "alphabetic-asc":
            sortedProducts.sort((a, b) => a.title.localeCompare(b.title));
            break;
          case "alphabetic-desc":
            sortedProducts.sort((a, b) => b.title.localeCompare(a.title));
            break;
          case "rating-high-low":
            sortedProducts.sort((a, b) => b.rating - a.rating);
            break;
          case "rating-low-high":
            sortedProducts.sort((a, b) => a.rating - b.rating);
            break;
          case "popularity":
            sortedProducts.sort((a, b) => (b.popularity || 0) - (a.popularity || 0));
            break;
          default:
            break;
        }

        setProductList(sortedProducts);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching products:", error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, [filter]);

  const handleProductClick = (product) => {
    navigate(`/product/${product.id}`, { state: { product } });
  };

  return (
    <div className="product-grid">
      {loading ? (
        <p className="loading-placeholder">Loading products...</p>
      ) : productList.length > 0 ? (
        productList.map((product) => (
          <ProductCard
            key={product.id}
            id={product.id}
            title={product.title || product.name || "Unnamed Product"}
            price={product.price || 0}
            rating={product.rating || 0}
            image={(product.images && product.images[0]) || "https://via.placeholder.com/150"}
            onClick={() => handleProductClick(product)}
          />
        ))
      ) : (
        <p className="loading-placeholder">No products available in this category...</p>
      )}
    </div>
  );
}

export default ProductGrid;
